import { CompassIcon, SplitIcon, TrendingUpIcon, ZapIcon, FlagIcon } from 'lucide-react';

export const infoSources = [
  'Swim workouts',
  'Bike workouts',
  'Running plans',
  'Nutrition advice',
  'Recovery recommendations',
  'Race-day checklists',
];

export const selfQuestions = [
  'Am I training enough?',
  'Am I training too much?',
  'What should I do this week?',
  'How should I balance swim, bike and run?',
  'When should I push?',
  'When should I recover?',
  'How should I fuel long sessions?',
  "How do I know whether I'm actually progressing?",
  'What happens when race week finally arrives?',
];

export const painPoints: {
  icon: typeof CompassIcon;
  title: string;
  body: string[];
  list?: string[];
  resolve?: string;
}[] = [
  {
    icon: CompassIcon,
    title: "You don't know where to start",
    body: [
      'A full-distance triathlon requires months of preparation.',
      "Without a clear structure, it's easy to jump between workouts and information without understanding how everything fits together.",
    ],
    resolve: 'THE FULL DISTANCE TRIATHLON SYSTEM™ organizes the journey into six progressive phases.',
  },
  {
    icon: SplitIcon,
    title: 'Your three disciplines feel disconnected',
    body: [
      'Swim. Bike. Run. Three disciplines. One race.',
      'Your preparation needs to connect them instead of treating them as completely separate activities.',
    ],
  },
  {
    icon: TrendingUpIcon,
    title: "You don't know if you're actually progressing",
    body: [
      "Training harder doesn't automatically mean training better.",
      "Without a structured way to monitor consistency, training load and progression, it's difficult to understand whether you're moving in the right direction.",
    ],
  },
  {
    icon: ZapIcon,
    title: "You're not sure how to handle fueling",
    body: [
      'A full-distance event demands a completely different level of endurance.',
      'Training is only one part of the equation. Fueling, hydration and energy management become increasingly important as the distance increases.',
    ],
  },
  {
    icon: FlagIcon,
    title: "You're worried about race day",
    body: ['You can spend months training and still arrive at race week wondering:'],
    list: [
      'What do I pack?',
      'What do I do the night before?',
      'How should I organize race morning?',
      'What happens during transitions?',
      'How do I approach the different stages of the race?',
    ],
    resolve: "A strong race doesn't begin at the starting line. It begins with preparation.",
  },
];
